import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonLabel,
  IonSpinner,
} from '@ionic/react';
import { isObject } from 'lodash';
import React, { ReactElement, memo } from 'react';
import { Machine } from '../../../api/graphql/generated';
import { useMachineVariables } from '../../../api/hooks/machine-variable.hooks';
import i18n from '../../../i18n';
import { useBeaconRouter } from '../../../route/route.hooks';
import { useMachineVariableFavorites } from '../../../store/favorites/favorites.hooks';
import {
  URVariable,
  stringifyURVariable,
} from '../../../util/machine-variable.utils';

interface VariablesCardProps {
  machine?: Machine;
}

const VariablesCard = memo((props: VariablesCardProps): ReactElement => {
  const { machine } = props;

  const variables = useMachineVariables({
    id: machine?.id,
  });
  const favs = useMachineVariableFavorites(machine);

  const { builder } = useBeaconRouter();

  return (
    <IonCard
      className="machine-card-container"
      routerLink={
        machine
          ? builder.getMachineVariablesRoute(machine.teamId, machine.id)
          : undefined
      }
    >
      <IonCardHeader>
        <IonCardTitle>
          {i18n.t('common:machine_variables_favorites')}
        </IonCardTitle>
      </IonCardHeader>
      {favs?.length ? (
        <div className="machine-card-info-grid">
          {favs?.map((fav, index) => {
            const hasValue = variables[fav] !== undefined;
            const value = isObject(variables[fav])
              ? stringifyURVariable(variables[fav] as URVariable)
              : String(variables[fav]);
            return (
              <React.Fragment key={index}>
                <div className="machine-card-info-grid-label">
                  <IonLabel color="medium">{fav}</IonLabel>
                </div>
                <div className="machine-card-info-grid-value">
                  {hasValue ? (
                    <IonLabel
                      className="ion-text-end"
                      color="medium"
                      slot="end"
                    >
                      {value}
                    </IonLabel>
                  ) : (
                    <IonSpinner name="dots" />
                  )}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      ) : (
        <GettingStartedWithVariables />
      )}
    </IonCard>
  );
});

VariablesCard.displayName = 'VariablesCard';

const GettingStartedWithVariables = (): ReactElement => {
  return (
    <p className="card-description">
      {i18n.t('common:get_started_with_variables')}
    </p>
  );
};

export { VariablesCard };
